export default {
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: 'Deseja remover a especialidade <strong>' + this.currentEntity.label + '</strong>?'
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/record/specialities/index/resources/computed.js